import React from 'react';
import { useTranslation } from 'react-i18next';
import Box from '../../shared/atoms/Box';
import Text from '../../shared/atoms/Text';
import Badge from '../../shared/atoms/Badge';
import Button from '../../shared/atoms/Button';
import Separator from '../../Separator';
import ProposedSlotsList from './ProposedSlotsList';
import { horaireLong, majuscule } from '../../../annuaire/tunnel/creneaux';
import {
  workshopBookingStatusKey,
  workshopBookingStatusColor,
  isPendingWorkshopBooking,
} from '../../../utils/workshopBookingStatus';

/**
 * FIXERLIGHT-052 lot 1 — une ligne de la liste « Mes rendez-vous
 * d'atelier ». Lecture seule : aucun bouton annuler/déplacer/reprendre
 * rendez-vous (lot 2, avec FIXERLIGHT-013).
 */
const WorkshopBookingCard = ({ booking }) => {
  const { t } = useTranslation();
  const pending = isPendingWorkshopBooking(booking.status);
  const statusKey = workshopBookingStatusKey(booking.status);

  return (
    <Box
      borderColor="gray.light"
      borderWidth="1px"
      borderRadius="sm"
      borderStyle="solid"
      mb={5}
      p={{ xs: 2, lg: 5 }}
      data-testid="workshop-booking-card">
      <Box
        flexDirection="row"
        flexWrap="wrap"
        justifyContent="space-between"
        style={{ rowGap: 8 }}>
        <Box>
          <Text color="black">{booking.shop && booking.shop.name}</Text>
          {/* FIXERLIGHT-267 : le numéro rendu par l'api (« RDV-4821 »),
              affiché tel quel ; absent → rien. */}
          {!!booking.reference && (
            <Text
              color="gray.dark"
              fontSize={1}
              data-testid="workshop-booking-reference">
              {t('workshopappointments.reference', {
                reference: booking.reference,
              })}
            </Text>
          )}
        </Box>
        {statusKey && (
          <Badge color={workshopBookingStatusColor(booking.status)} light>
            {t(statusKey)}
          </Badge>
        )}
      </Box>
      <Separator mt={4} axe="horizontal" />
      <Box
        flexDirection={{ xs: 'column', lg: 'row' }}
        justifyContent="space-between"
        pt={{ xs: 2, lg: 0 }}>
        <Box style={{ flex: 3 }} pt={{ xs: 2, lg: 0 }}>
          {pending ? (
            <ProposedSlotsList slots={booking.proposed_slots} />
          ) : (
            <Text fontWeight={2} mb={2} variant="large" color="black">
              {majuscule(horaireLong(booking.scheduled_at))}
            </Text>
          )}
          {/* FIXERLIGHT-074 : sans adresse (rendez-vous posé par l'atelier
              sans compte client, ou toute autre valeur vide), pas de ligne
              « Adresse : » vide plutôt qu'un libellé sans contenu. */}
          {!!booking.address && (
            <Text>
              <b style={{ fontWeight: 500 }}>{t('address')}</b> :{' '}
              {booking.address}
            </Text>
          )}
        </Box>
        <Box mt={{ xs: 3, lg: 0 }}>
          <Button
            fullWidth
            variant="filled"
            to={`/account/rendez-vous-atelier/${booking.id}`}>
            {t('seedetails')}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default WorkshopBookingCard;
